module.exports = __webpack_public_path__ + "img/panda_help_icon.d0918345.svg";